import { FC, useMemo } from "react";
import { t } from "i18next";

import { vatHandlingType } from "@enums/hooks.enum";
import { PriceSummaryProps } from "@models/services/pricing";
import { formatPrice } from "@utils/common.utils";

import { PriceRow } from "../PriceRow/PriceRow";

export const PriceSummary: FC<PriceSummaryProps> = ({
  basePrice,
  currency,
  guestPrice,
  isFromDrawer = false,
  resourceLabel,
  totalPriceWithTax,
  vatAmount,
  vatDetails,
}) => {
  const isVatInclusive = useMemo(
    () =>
      vatDetails?.hasVat &&
      vatDetails?.vatHandlingType === vatHandlingType.INCLUSIVE,
    [vatDetails?.hasVat, vatDetails?.vatHandlingType]
  );

  const isVatExclusive = useMemo(
    () =>
      vatDetails?.hasVat &&
      vatDetails?.vatHandlingType === vatHandlingType.EXCLUSIVE,
    [vatDetails?.hasVat, vatDetails?.vatHandlingType]
  );

  const firstRowClass = isFromDrawer ? "col-7" : "col-9";
  const secondRowClass = isFromDrawer ? "col-5 text-end" : "col-3 text-end";

  return (
    <div className="fg-tab-unit-list fg-border-none">
      <div className="total-prize-section">
        <PriceRow
          label={t("priceOfTheUnit", { unit: resourceLabel })}
          amount={formatPrice(basePrice, currency)}
          firstRowClass={firstRowClass}
          secondRowClass={secondRowClass}
        />

        {guestPrice > 0 && (
          <PriceRow
            label={t("GuestPrice")}
            amount={formatPrice(guestPrice, currency)}
            firstRowClass={firstRowClass}
            secondRowClass={secondRowClass}
          />
        )}

        {isVatExclusive && (
          <PriceRow
            label={t("VAT")}
            amount={formatPrice(vatAmount ?? 0, currency)}
            labelClassName="unit-vat-label"
            showMarginTop
            secondaryLabel={`(${t(vatDetails.vatHandlingType.toLowerCase())} ${vatDetails.vatPercentage}%)`}
            firstRowClass={firstRowClass}
            secondRowClass={secondRowClass}
          />
        )}

        <hr />

        <PriceRow
          label={t("totalPriceToPay")}
          amount={formatPrice(totalPriceWithTax, currency)}
          labelClassName={isVatInclusive ? "unit-vat-label" : ""}
          secondaryLabel={`${
            isVatInclusive
              ? "(" +
                t(vatDetails.vatHandlingType.toLowerCase()) +
                ` ${vatDetails.vatPercentage}% )`
              : ""
          }`}
          firstRowClass={firstRowClass}
          secondRowClass={secondRowClass}
        />
      </div>
    </div>
  );
};
